module.exports = __webpack_public_path__ + "static/media/LAB-LOGO.89ded1d3.png";